// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentMethod-module__container___2mozp","icon":"PaymentMethod-module__icon___1oKwt","icon_card":"PaymentMethod-module__icon_card___3ka3N"};